import { Box, Button } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import LoadingIcon from "../LoadingIcon";

export default function ContainedButton({
  onClick,
  color,
  size,
  disabled = false,
  loading = false,
  children,
  sxProps = {},
  ...props
}) {
  const colors = useColors();

  const colorMap = {
    primary: {
      text: colors.button_contained_primary_enabled_text,
      enabled: {
        bg: colors.button_contained_primary_enabled_bg,
      },
      hover: {
        bg: colors.button_contained_primary_hovered_bg,
      },
      disabled: {
        text: colors.button_contained_disabled_text,
        bg: colors.button_contained_disabled_bg,
      },
    },
    success: {
      text: colors.button_contained_success_enabled_text,
      enabled: {
        bg: colors.button_contained_success_enabled_bg,
      },
      hover: {
        bg: colors.button_contained_success_hovered_bg,
      },
      disabled: {
        text: colors.button_contained_disabled_text,
        bg: colors.button_contained_disabled_bg,
      },
    },
    // TODO -  add inherit, success, error, etc.. and edit the documentation!
  };

  const sizeMap = {
    xs: {
      fontSize: "12px",
      fontWeight: 400,
      height: "24px",
      minWidth: "64px",
      paddingX: "8px",
      borderRadius: "10px",
      loadingSize: 6,
    },
    small: {
      fontSize: "12px",
      fontWeight: 500,
      height: "32px",
      minWidth: "64px",
      paddingX: "10px",
      borderRadius: "10px",
      loadingSize: 8,
    },
    medium: {
      fontSize: "14px",
      fontWeight: 500,
      height: "36px",
      minWidth: "64px",
      paddingX: "10px",
      borderRadius: "12px",
      loadingSize: 10,
    },
    large: {
      fontSize: "14px",
      fontWeight: 500,
      height: "48px",
      minWidth: "64px",
      paddingX: "10px",
      borderRadius: "14px",
      loadingSize: 12,
    },
  };

  const colorConfig = colorMap[color];
  const sizeConfig = sizeMap[size];

  return (
    <Button
      variant="text"
      onClick={onClick}
      disabled={disabled || loading}
      disableRipple
      disableFocusRipple
      disableElevation
      sx={{
        position: "relative",
        textTransform: "none",
        fontSize: sizeConfig.fontSize,
        fontWeight: sizeConfig.fontWeight,
        height: sizeConfig.height,
        paddingX: sizeConfig.paddingX,
        width: "fit-content",
        minWidth: sizeConfig.minWidth,
        borderRadius: sizeConfig.borderRadius,
        color: colorConfig.text,
        backgroundColor: colorConfig.enabled.bg,
        "&:hover": {
          backgroundColor: colorConfig.hover.bg,
        },
        "&:disabled": {
          backgroundColor: colorConfig.disabled.bg,
          color: colorConfig.disabled.text,
        },
        ...sxProps,
      }}
      {...props}
    >
      <span style={{ visibility: loading ? "hidden" : "visible" }}>
        {children}
      </span>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadingIcon type="circular" size={sizeConfig.loadingSize} />
        </Box>
      )}
    </Button>
  );
}
